import { useState } from "react";
import { ArrowRight, Copy, Check } from "lucide-react";
import { Reveal, Overline } from "./primitives";
import { COURSE1_URL } from "../../config";

export const TryCourse = () => {
  const [copied, setCopied] = useState(false);

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText("TRANSFORM");
    } catch {
      const ta = document.createElement("textarea");
      ta.value = "TRANSFORM";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <section id="try-course" data-testid="trycourse-section" className="bg-alabaster py-24 md:py-32">
      <div className="mx-auto grid max-w-[1200px] items-center gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5" y={40}>
          <div className="relative">
            <div className="glow-float absolute -inset-5 -z-10 rounded-full bg-terracotta/15 blur-3xl" />
            <img
              src="/images/becoming-unmistakable.jpg"
              alt="Becoming Unmistakable — the first course of Creating Wealth Through Community"
              data-testid="trycourse-image"
              loading="lazy"
              className="w-full rounded-[2px] shadow-[0_30px_70px_-30px_rgba(26,26,24,0.4)]"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal><Overline>Not Ready for the Whole Journey?</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-3xl font-medium leading-[1.05] tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Try the first course: <span className="italic text-terracotta">Becoming Unmistakable.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl font-sans text-lg font-light leading-relaxed text-stonegray">
              Take Course 1 on its own — no membership, no commitment to the full program. Meet the real you, name
              what's been getting in your way, and discover your Superpower. If it moves you, the rest of the journey
              will be waiting.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 flex flex-wrap items-baseline gap-x-4 gap-y-2">
              <span className="font-display text-3xl text-stonegray line-through decoration-terracotta/70 decoration-2 md:text-4xl">$197</span>
              <span data-testid="trycourse-price" className="font-display text-5xl font-medium text-ink md:text-6xl">$47</span>
              <span className="font-sans text-sm font-light text-stonegray">one time · with code below</span>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-6 inline-flex flex-wrap items-center gap-4 border border-ink/15 bg-ivory px-6 py-4">
              <span className="font-sans text-xs font-medium uppercase tracking-[0.24em] text-stonegray">Use code</span>
              <span data-testid="trycourse-code" className="font-display text-2xl font-medium tracking-wide text-terracotta">TRANSFORM</span>
              <span className="font-sans text-xs font-light text-stonegray">for $150 off at checkout</span>
              <button
                data-testid="trycourse-copy-code-btn"
                onClick={copyCode}
                className="inline-flex items-center gap-2 border border-ink/20 px-3 py-1.5 font-sans text-[0.65rem] font-medium uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:border-terracotta hover:text-terracotta"
              >
                {copied ? <Check className="h-3 w-3 text-terracotta" strokeWidth={1.8} /> : <Copy className="h-3 w-3" strokeWidth={1.6} />}
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-8">
              <a
                href={COURSE1_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="trycourse-cta"
                className="group inline-flex items-center gap-3 bg-terracotta px-8 py-4 font-sans text-sm font-medium uppercase tracking-[0.14em] text-white transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-ink"
              >
                <span>Try the First Course — $47</span>
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" strokeWidth={1.6} />
              </a>
              <p className="mt-3 font-sans text-xs font-light tracking-wide text-stonegray">
                Enter TRANSFORM at checkout to bring $197 down to $47.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
